import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PpDruh = {
	name: NAME,
	apiProvider,
	router,
};
